import { TitleCasePipe, CurrencyPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { SubscriptionPlanName } from '../../../../models/subscription-plan';
import { FlexComponent } from '../../../../ui-kit/flex/flex.component';

@Component({
  selector: 'app-early-pay-calculator-plan-plate',
  templateUrl: './early-pay-calculator-plan-plate.component.html',
  styleUrls: ['./early-pay-calculator-plan-plate.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FlexComponent, MatButtonModule, MatIconModule, TitleCasePipe, CurrencyPipe],
})
export class EarlyPayCalculatorPlanPlateComponent {
  @Input() selectedPlan: SubscriptionPlanName;
  @Input() planName: SubscriptionPlanName;
  @Input() price: number;
  @Input() upfrontFee: number;
  @Input() fee: number;
  @Input() eppIdealAmount: string;
  @Input() isAnnualSubscription = false;
  @Input() arePlansExpanded = false;

  @Output() selectSubscriptionPlan: EventEmitter<SubscriptionPlanName> = new EventEmitter<SubscriptionPlanName>();
  @Output() togglePlansExpanding: EventEmitter<boolean> = new EventEmitter<boolean>();

  onSelectSubscriptionPlan(planName: SubscriptionPlanName): void {
    this.selectSubscriptionPlan.emit(planName);
  }

  onTogglePlansExpanding(isExpanded: boolean): void {
    this.togglePlansExpanding.emit(isExpanded);
  }
}
